import StepProgress from '@src/features/user/checkout/layout/StepProgress';
import { useCheckoutStore } from '@src/stores/checkoutStore';
import { useEffect, useMemo } from 'react';
import { Button } from '@src/features/ui';
import { useNavigate } from 'react-router-dom';

export const Congratulations = () => {
  const {
    platform,
    setTypeIndex,
    setSizeIndex,
    typeIndex,
    sizeIndex,
    packages,
  } = useCheckoutStore();

  const navigate = useNavigate();

  useEffect(() => {
    if (!platform) navigate('/select-trading-platform');
  }, [navigate, platform]);

  const goBack = () => {
    setTypeIndex(undefined);
    setSizeIndex(undefined);
    navigate('/select-trading-platform');
  };
  const selectedPackage = useMemo(() => {
    return packages?.[sizeIndex || 0];
  }, [sizeIndex, packages]);

  if (!platform) return null;

  return (
    <div className="">
      <div className="flex-1 w-full">
        <div
          className="max-w-[1440px] m-auto px-5 mt-4 py-4 flex flex-row justify-between gap-x-10"
          style={{
            backgroundColor:
              'rgba(255, 255, 255, 0.05)' /* 5% = 0.05 opacity */,
            backdropFilter: 'blur(200px)',
            minHeight: 'calc(100vh - 235px)',
          }}
        >
          <div className="flex-1">
            <div className="mb-11.5">
              <StepProgress
                accountType={typeIndex}
                current={6}
                platform={platform}
                selectedPackage={selectedPackage}
                total={5}
                onClick={(step) => {
                  console.log(step);
                  if (!step) navigate('/select-trading-platform');
                }}
              />
            </div>
            <div className="flex flex-col gap-[15px]">
              <div className="bg-[#1F2734] rounded-[10px] p-[20px] flex flex-col gap-[30px]">
                <div className="flex flex-col items-center justify-center p-[30px] pt-5 bg-[#253348] rounded-[10px] border-[#33455F] border">
                  <img
                    alt="congratulations-image"
                    className="w-[220px] h-[180px] object-contain"
                    src="/public/assets/congratulations-image.png"
                  />
                  <p className="font-bold text-[26px] w-[230px] text-center mt-[30px] leading-[100%]">
                    Congratulations on you purchase!
                  </p>
                </div>
                <div className="max-w-[1440px] m-auto px-6 lg:px-[60px] flex justify-between items-center h-full">
                  <Button
                    className="px-8"
                    size="lg"
                    variant="outline"
                    onClick={goBack}
                  >
                    Back To Home
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full sticky bottom-0 backdrop-blur-[30px] bg-[linear-gradient(90deg,rgba(23,29,35,0.8)_0%,rgba(23,29,35,0.8)_100%)] border-t border-[#255589] h-[100px]" />
    </div>
  );
};
